import React from "react";
import { Link, useLocation } from "react-router-dom";
import { canOpenPath, firstOpenScreen, isSystemUser } from "../../helpers/permissions";
import { trackLogout } from "../../helpers/activityTracker";

/** Pages of the backend team only (not in AppMenu, so no access rights). */
const SYSTEM_USER_PAGES = ["/app-menu"];
const allowed = (path) =>
  SYSTEM_USER_PAGES.some((p) => path.toLowerCase() === p || path.toLowerCase().startsWith(`${p}/`)) ? isSystemUser() : canOpenPath(path);

const logout = () => {
  trackLogout();
  sessionStorage.clear();
  window.location.href = "/";
};

/**
 * Shows the page only when the logged-in user may view its screen (Users › Access rights); otherwise a short note with
 * a link to the first screen the user may view, or — when no screen is given yet — Logout (no link back to a page that
 * is blocked too). Routes that are not a managed screen stay open.
 */
export default function RightsGate({ children }) {
  const { pathname } = useLocation();
  if (allowed(pathname)) return children;
  const home = firstOpenScreen();
  const canGoHome = home && home.route.toLowerCase() !== pathname.toLowerCase();
  return (
    <div className="text-center p-5">
      <i className="fas fa-lock fa-2x mb-3" aria-hidden="true" />
      {home ? (
        <>
          <h5>You do not have access to this page</h5>
          <p className="text-muted">Ask an administrator to give you View rights on Users › Access rights.</p>
          {canGoHome && (
            <Link to={home.route} className="btn btn-outline-primary btn-sm">
              Go to {home.menuName || "your first screen"}
            </Link>
          )}
        </>
      ) : (
        <>
          <h5>No screen has been given to you yet</h5>
          <p className="text-muted">Ask an administrator to give you View rights on Users › Access rights, then log in again.</p>
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={logout}>
            <i className="fas fa-sign-out-alt" aria-hidden="true" /> Logout
          </button>
        </>
      )}
    </div>
  );
}
